import React from "react";
import { TotumLogo } from "@Components/shared/TotumLogo";
import { HologicLogo } from "@Components/shared/HologicLogo";
import { IDictionary } from "./types";
import { MedtronicLogo } from "@Components/shared/MedtronicLogo";

interface IProps {
    style?: IDictionary;
}

const Logo: React.FC<IProps> = ({ style }: IProps) => {
    switch (window["branding"]) {
        default:
            return <TotumLogo style={style} />;

        case "hologic":
            return <HologicLogo style={style} />;

        case "medtronic":
            return <MedtronicLogo style={style} />;
    }
};
export default Logo;
